// Proyecto NISSAN CEIBA
import img1_ceiba from "../assets/projects/NissanCeiba/img1.webp";
import img2_ceiba from "../assets/projects/NissanCeiba/img2.webp";
import img3_ceiba from "../assets/projects/NissanCeiba/img3.webp";
import img4_ceiba from "../assets/projects/NissanCeiba/img4.webp";
import img5_ceiba from "../assets/projects/NissanCeiba/img5.webp";
import img6_ceiba from "../assets/projects/NissanCeiba/img6.webp";
import img7_ceiba from "../assets/projects/NissanCeiba/img7.webp";
import img8_ceiba from "../assets/projects/NissanCeiba/img8.webp";
import img10_ceiba from "../assets/projects/NissanCeiba/img10.webp";
import principal_ceiba from "../assets/projects/NissanCeiba/Principal.webp";
// Proyecto Grupo Q La Ceiba
import ceiba_gq from "../assets/projects/GrupoQCeiba/ceibaGrupoQ.webp";
import ceiba2_gq from "../assets/projects/GrupoQCeiba/CeibaGrupoQ2.webp";
import wh_gq from "../assets/projects/GrupoQCeiba/Wh.webp";
import wh20_gq from "../assets/projects/GrupoQCeiba/WhatsApp Image 20.webp";
import whpm_gq from "../assets/projects/GrupoQCeiba/WhatsApp Image 2026-05-24 at 10.15.19 PM.webp";
import whplanos_gq from "../assets/projects/GrupoQCeiba/WhatsApp Image 2026-06-05 at 4.44.51 PM.webp";
// Proyecto NISSAN choluteca
import img1_choluteca from "../assets/projects/GrupoQCholuteca/img1.webp";
import img2_choluteca from "../assets/projects/GrupoQCholuteca/img2.webp";
import img3_choluteca from "../assets/projects/GrupoQCholuteca/img3.webp";
import img4_choluteca from "../assets/projects/GrupoQCholuteca/img4.webp";
import img5_choluteca from "../assets/projects/GrupoQCholuteca/img5.webp";
import img6_choluteca from "../assets/projects/GrupoQCholuteca/img6.webp";
import img7_choluteca from "../assets/projects/GrupoQCholuteca/img7.webp";
import img8_choluteca from "../assets/projects/GrupoQCholuteca/img8.webp";
import chol_n1 from "../assets/projects/GrupoQCholuteca/IMG_8313.webp";
import chol_n2 from "../assets/projects/GrupoQCholuteca/IMG_8349.webp";
import chol_n3 from "../assets/projects/GrupoQCholuteca/IMG_8366.webp";
import chol_n4 from "../assets/projects/GrupoQCholuteca/IMG_8411.webp";
import chol_n5 from "../assets/projects/GrupoQCholuteca/IMG_8458.webp";
import chol_n6 from "../assets/projects/GrupoQCholuteca/IMG_8520.webp";
import chol_n7 from "../assets/projects/GrupoQCholuteca/IMG_8537.webp";
import chol_n8 from "../assets/projects/GrupoQCholuteca/IMG_8614.webp";
import chol_n9 from "../assets/projects/GrupoQCholuteca/IMG_8619.webp";
import chol_n10 from "../assets/projects/GrupoQCholuteca/IMG_8633.webp";
import chol_n11 from "../assets/projects/GrupoQCholuteca/IMG_8642.webp";
// poyecto bodega servelec
import img1_servelec from "../assets/projects/BodegaServelec/img1.webp";
import img2_servelec from "../assets/projects/BodegaServelec/img2.webp";
import img3_servelec from "../assets/projects/BodegaServelec/img3.webp";
import img4_servelec from "../assets/projects/BodegaServelec/img4.webp";
import img5_servelec from "../assets/projects/BodegaServelec/img5.webp";
import img6_servelec from "../assets/projects/BodegaServelec/img6.webp";
import img7_servelec from "../assets/projects/BodegaServelec/WhatsApp Image 2026-05-28 at 11.08.36 AM.webp";
// proyecto cancha
import img1_cancha from "../assets/projects/CanchaTexiguat/img1.webp";
import img2_cancha from "../assets/projects/CanchaTexiguat/img2.webp";
import img3_cancha from "../assets/projects/CanchaTexiguat/img3.webp";
import img4_cancha from "../assets/projects/CanchaTexiguat/img4.webp";
import img5_cancha from "../assets/projects/CanchaTexiguat/img5.webp";
import img6_cancha from "../assets/projects/CanchaTexiguat/img6.webp";
import img7_cancha from "../assets/projects/CanchaTexiguat/img7.webp";
// proyecto puente peatonal
import img1_puente from "../assets/projects/PuentePeatonal/img2.webp";
import img2_puente from "../assets/projects/PuentePeatonal/img4.webp";
import img3_puente from "../assets/projects/PuentePeatonal/img5.webp";
import img4_puente from "../assets/projects/PuentePeatonal/img6.webp";
import img5_puente from "../assets/projects/PuentePeatonal/img8.webp";
import img6_puente from "../assets/projects/PuentePeatonal/img9.webp";
import img7_puente from "../assets/projects/PuentePeatonal/img1.webp";
// proyecto tatumbla
import img1_Plaza from "../assets/projects/PlazaTatumbla/img1.webp";
import img2_Plaza from "../assets/projects/PlazaTatumbla/img2.webp";
import img3_Plaza from "../assets/projects/PlazaTatumbla/img3.webp";
import img4_Plaza from "../assets/projects/PlazaTatumbla/img4.webp";
import img5_Plaza from "../assets/projects/PlazaTatumbla/img5.webp";
import img6_Plaza from "../assets/projects/PlazaTatumbla/img6.webp";
// proyecto Diseño de Sistemas de Agua Potable
import agua1 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.27.05 AM.webp";
import agua2 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.28.19 AM.webp";
import agua3 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.28.21 AM.webp";
import agua4 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.28.49 AM.webp";
import agua5 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.29.35 AM.webp";
import agua6 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.29.55 AM.webp";
import agua7 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 9.58.49 AM.webp";
import agua8 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 10.49.12 AM.webp";
import agua9 from "../assets/projects/AguaPotable/WhatsApp Image 2026-05-28 at 11.07.40 AM.webp";
// proyecto Construcciones Escolares
import esc1 from "../assets/projects/ConstruccionEscolares/escuela_1 (1).webp";
import esc2 from "../assets/projects/ConstruccionEscolares/escuela_1 (2).webp";
import esc3 from "../assets/projects/ConstruccionEscolares/escuela_1 (3).webp";
import esc4 from "../assets/projects/ConstruccionEscolares/escuela_1 (4).webp";
import esc5 from "../assets/projects/ConstruccionEscolares/escuela_1 (5).webp";
import esc6 from "../assets/projects/ConstruccionEscolares/escuela_1 (6).webp";
import esc7 from "../assets/projects/ConstruccionEscolares/escuela_1 (7).webp";
// proyecto Construcción de Piscinas
import pisc1 from "../assets/projects/ConstruccionPiscinas/piscina_1 (1).webp";
import pisc2 from "../assets/projects/ConstruccionPiscinas/piscina_1 (2).webp";
import pisc3 from "../assets/projects/ConstruccionPiscinas/piscina_1 (3).webp";
import pisc4 from "../assets/projects/ConstruccionPiscinas/piscina_1 (4).webp";
import pisc_w1 from "../assets/projects/ConstruccionPiscinas/WhatsApp Image 2026-06-10 at 8.46.32 PM.webp";
import pisc_w2 from "../assets/projects/ConstruccionPiscinas/WhatsApp Image 2026-06-10 at 8.47.33 PM.webp";
import pisc_w3 from "../assets/projects/ConstruccionPiscinas/WhatsApp Image 2026-06-10 at 8.51.26 PM.webp";
import pisc_w4 from "../assets/projects/ConstruccionPiscinas/WhatsApp Image 2026-06-10 at 8.52.06 PM.webp";
import pisc_w5 from "../assets/projects/ConstruccionPiscinas/WhatsApp Image 2026-06-10 at 8.57.08 PM.webp";
// proyecto Diseño de Viviendas
import dise1_viv from "../assets/projects/DiseñoViviendas/dise_1 (1).webp";
import dise2_viv from "../assets/projects/DiseñoViviendas/dise_1 (2).webp";
import dise3_viv from "../assets/projects/DiseñoViviendas/dise_1 (3).webp";
import dise_w1 from "../assets/projects/DiseñoViviendas/WhatsApp Image 2026-06-10 at 7.41.14 PM.webp";
import dise_w2 from "../assets/projects/DiseñoViviendas/WhatsApp Image 2026-06-10 at 7.45.38 PM.webp";
import dise_w3 from "../assets/projects/DiseñoViviendas/WhatsApp Image 2026-06-10 at 7.47.15 PM.webp";
import dise_w4 from "../assets/projects/DiseñoViviendas/WhatsApp Image 2026-06-10 at 7.51.01 PM.webp";
// proyecto Plaza Municipal Soledad
import sol1 from "../assets/projects/PlazaMunicipalSoledad/WhatsApp Image 2026-06-10 at 8.44.32 PM.webp";
import sol2 from "../assets/projects/PlazaMunicipalSoledad/WhatsApp Image 2026-06-10 at 8.44.32 PM (1).webp";
import sol3 from "../assets/projects/PlazaMunicipalSoledad/WhatsApp Image 2026-06-10 at 8.44.33 PM.webp";
import sol4 from "../assets/projects/PlazaMunicipalSoledad/WhatsApp Image 2026-06-10 at 8.44.33 PM (1).webp";
import sol5 from "../assets/projects/PlazaMunicipalSoledad/WhatsApp Image 2026-06-10 at 8.44.33 PM (2).webp";
// proyecto Huellas
import img1_huellas from "../assets/projects/Huellas/img1.webp";
import img3_huellas from "../assets/projects/Huellas/img3.webp";
import img6_huellas from "../assets/projects/Huellas/img6.webp";
import img9_huellas from "../assets/projects/Huellas/img9.webp";
import img10_huellas from "../assets/projects/Huellas/img10.webp";
import img11_huellas from "../assets/projects/Huellas/img11.webp";
import img12_huellas from "../assets/projects/Huellas/img12.webp";
import img14_huellas from "../assets/projects/Huellas/img14.webp";
import img15_huellas from "../assets/projects/Huellas/img15.webp";
import img16_huellas from "../assets/projects/Huellas/img16.webp";
import img18_huellas from "../assets/projects/Huellas/img18.webp";
import img19_huellas from "../assets/projects/Huellas/img19.webp";
import img22_huellas from "../assets/projects/Huellas/img22.webp";
// proyecto Pavimento Hidráulico
import img7_pav from "../assets/projects/pavimentoHidraulico/img (7).webp";
import img12_pav from "../assets/projects/pavimentoHidraulico/img (12).webp";
import img13_pav from "../assets/projects/pavimentoHidraulico/img (13).webp";
import pav_w1 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.30.02 PM.webp";
import pav_w2 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.33.51 PM.webp";
import pav_w3 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.34.21 PM.webp";
import pav_w4 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.34.22 PM.webp";
import pav_w5 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.45.09 PM.webp";
import pav_w6 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.51.49 PM.webp";
import pav_w7 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.52.13 PM.webp";
import pav_w8 from "../assets/projects/pavimentoHidraulico/WhatsApp Image 2026-05-12 at 6.54.02 PM.webp";
// proyecto Remodelación de Viviendas
import remod_w1 from "../assets/projects/remodelacionViviendas/WhatsApp Image 2026-06-10 at 8.47.54 PM.webp";
import remod_w2 from "../assets/projects/remodelacionViviendas/WhatsApp Image 2026-06-10 at 8.56.08 PM.webp";
import remod_w3 from "../assets/projects/remodelacionViviendas/WhatsApp Image 2026-06-10 at 8.56.08 PM (1).webp";
import remod_w4 from "../assets/projects/remodelacionViviendas/WhatsApp Image 2026-06-10 at 8.56.08 PM (2).webp";
import remod_w5 from "../assets/projects/remodelacionViviendas/WhatsApp Image 2026-06-10 at 8.58.59 PM.webp";
import remod_w6 from "../assets/projects/remodelacionViviendas/WhatsApp Image 2026-06-10 at 8.59.18 PM.webp";
// proyecto Caja Puente Mayarán
import may_w1 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.12.33 PM.webp";
import may_w2 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.12.41 PM.webp";
import may_w3 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.12.49 PM.webp";
import may_w4 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.13.04 PM.webp";
import may_w5 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.26.06 PM.webp";
import may_w6 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.26.41 PM.webp";
import may_w7 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.27.17 PM.webp";
import may_w8 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.27.39 PM.webp";
import may_w9 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.27.59 PM.webp";
import may_w10 from "../assets/projects/mayaran/WhatsApp Image 2026-06-10 at 9.28.14 PM.webp";
// proyecto Estadio Municipal Soledad
import est_w1 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.08.00 PM.webp";
import est_w2 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.08.32 PM.webp";
import est_w3 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.08.40 PM.webp";
import est_w4 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.09.08 PM.webp";
import est_w5 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.09.09 PM.webp";
import est_w6 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.09.32 PM.webp";
import est_w7 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.09.34 PM.webp";
import est_w8 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.09.47 PM.webp";
import est_w9 from "../assets/projects/EstadioSoledad/WhatsApp Image 2026-06-10 at 9.10.04 PM.webp";
// proyecto Obras de Terracería
import terr_w1 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.00.25 PM.webp";
import terr_w2 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.00.32 PM.webp";
import terr_w3 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.01.55 PM.webp";
import terr_w4 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.02.10 PM.webp";
import terr_w5 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.03.12 PM.webp";
import terr_w6 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.04.10 PM.webp";
import terr_w7 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.05.14 PM.webp";
import terr_w8 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.05.50 PM.webp";
import terr_w9 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.06.00 PM.webp";
import terr_w10 from "../assets/projects/terraceria/WhatsApp Image 2026-06-10 at 9.06.01 PM.webp";
// proyecto Adoquinado
import img1_adoq from "../assets/projects/Adoquinado/img (1).webp";
import img3_adoq from "../assets/projects/Adoquinado/img (3).webp";
import img4_adoq from "../assets/projects/Adoquinado/img (4).webp";
import img5_adoq from "../assets/projects/Adoquinado/img (5).webp";
import img6_adoq from "../assets/projects/Adoquinado/img (6).webp";
import img7_adoq from "../assets/projects/Adoquinado/img (7).webp";
import img8_adoq from "../assets/projects/Adoquinado/img (8).webp";
import img11_adoq from "../assets/projects/Adoquinado/img (11).webp";
import img12_adoq from "../assets/projects/Adoquinado/img (12).webp";
// proyecto Chevrolet SPS
import chevsps_cover from "../assets/projects/ChevroletSPS/IMG_8779.webp";
import chevsps1 from "../assets/projects/ChevroletSPS/IMG_8781.webp";
import chevsps2 from "../assets/projects/ChevroletSPS/IMG_8722.webp";
import chevsps3 from "../assets/projects/ChevroletSPS/IMG_8723.webp";
import chevsps4 from "../assets/projects/ChevroletSPS/IMG_8732.webp";
import chevsps5 from "../assets/projects/ChevroletSPS/IMG_8810.webp";
// proyecto Chevrolet Tegucigalpa
import chev_cover from "../assets/projects/chevrolet/IMG_6692.webp";
import chev1 from "../assets/projects/chevrolet/IMG_6699.webp";
import chev2 from "../assets/projects/chevrolet/IMG_7010.webp";
import chev3 from "../assets/projects/chevrolet/IMG_7827.webp";
import chev4 from "../assets/projects/chevrolet/IMG_7483.webp";
import chev5 from "../assets/projects/chevrolet/IMG_7690.webp";
import chev6 from "../assets/projects/chevrolet/IMG_7800.webp";
import chev7 from "../assets/projects/chevrolet/IMG_8027.webp";
import chev8 from "../assets/projects/chevrolet/IMG_8398.webp";
import chev9 from "../assets/projects/chevrolet/IMG_8019.webp";
import chev10 from "../assets/projects/chevrolet/IMG_8217.webp";
import chev11 from "../assets/projects/chevrolet/IMG_7987.webp";
import chev12 from "../assets/projects/chevrolet/IMG_8220.webp";
// proyecto Mantenimiento de Carretera
import img1_mant from "../assets/projects/MantenimientoCarretera/img (1).webp";
import img2_mant from "../assets/projects/MantenimientoCarretera/img (2).webp";
import img3_mant from "../assets/projects/MantenimientoCarretera/img (3).webp";
import img4_mant from "../assets/projects/MantenimientoCarretera/img (4).webp";
import img5_mant from "../assets/projects/MantenimientoCarretera/img (5).webp";
import img6_mant from "../assets/projects/MantenimientoCarretera/img (6).webp";
import img7_mant from "../assets/projects/MantenimientoCarretera/img (7).webp";
import img8_mant from "../assets/projects/MantenimientoCarretera/img (8).webp";
import img9_mant from "../assets/projects/MantenimientoCarretera/img (9).webp";
import img11_mant from "../assets/projects/MantenimientoCarretera/img 11.webp";
import img12_mant from "../assets/projects/MantenimientoCarretera/img 12.webp";

export const projectsData = [
  // Proyecto NISSAN CEIBA
  {
    id: "1",
    title: "Remodelación y cambio de Imagen Nissan-Grupo Q",
    category: "Proyectos Corporativos",
    location: "La ceiba, Honduras",
    year: "2026",
    area: "1200 m²",
    duration: "",
    status: "Completado",
    client: "Grupo Q",
    shortDescription:
      "Redefine la imagen con un diseño moderno, Equilibra impacto y funcionalidad, proyectando innovación.",
    fullDescription:
      "Este proyecto destaca por una transformación moderna y elegante de la marca Nissan, concebida para captar la atención desde el primer vistazo, pero manteniendo siempre como protagonista principal su producto: los vehículos. La renovación logra un equilibrio entre impacto visual y funcionalidad, integrando una fachada contemporánea con materiales de alta calidad que proyectan solidez y confianza. Cada elemento ha sido cuidadosamente diseñado para transmitir innovación, orden y carácter corporativo, dando como resultado un espacio que no solo moderniza la imagen del edificio, sino que también potencia la experiencia del cliente y refuerza la presencia de la marca en el mercado.",
    highlights: [
      "Equilibrio entre forma y función",
      "Proyección de confianza y solidez",
      "Imagen corporativa fortalecida",
      "Diseño limpio y funcional",
    ],
    coverImage: principal_ceiba,
    images: [
      img1_ceiba,
      img2_ceiba,
      img3_ceiba,
      img4_ceiba,
      img8_ceiba,
      img5_ceiba,
      img6_ceiba,
      img7_ceiba,
      img10_ceiba,
      ceiba_gq,
      wh_gq,
      whplanos_gq,
      ceiba2_gq,
      whpm_gq,
      wh20_gq,
    ],
    color: "#0B6B3A",
  },

  // PROYECTO GRUPO Q CHOLUTECA
  {
    id: "2",
    title: "Construcción de oficinas y área de taller Grupo Q",
    category: "Proyectos Corporativos",
    location: "Choluteca, Honduras",
    year: "2026",
    area: "2500 m²",
    duration: "",
    status: "En Proceso",
    client: "Grupo Q",
    shortDescription:
      "Un enfoque moderno y orientado al crecimiento. Prioriza eficiencia, seguridad e innovación.",
    fullDescription:
      "Este proyecto en ejecución refleja el inicio de una transformación estratégica empresarial, donde la construcción de oficinas y taller se plantea con una visión moderna, funcional y orientada al crecimiento. Desde esta etapa se puede apreciar la organización del sitio, la estructura metálica en desarrollo y la preparación del terreno, elementos clave que garantizan una base sólida y eficiente para el resultado final. La propuesta busca integrar espacios de trabajo cómodos y bien definidos con un área operativa óptima, priorizando la circulación, la seguridad y la productividad. Es un proceso donde cada detalle constructivo suma, proyectando una obra que no solo cumplirá con altos estándares de calidad, sino que también transmitirá innovación, orden y una identidad profesional alineada con las exigencias actuales del mercado.",
    highlights: [
      "Diseño orientado a productividad",
      "Enfoque moderno y crecimiento empresarial",
      "Áreas operativas bien integradas",
      "Enfoque en calidad e innovación",
    ],
    coverImage: chol_n10,
    images: [
      img1_choluteca,
      img2_choluteca,
      img3_choluteca,
      img4_choluteca,
      img5_choluteca,
      img6_choluteca,
      img7_choluteca,
      img8_choluteca,
      chol_n1,
      chol_n2,
      chol_n3,
      chol_n4,
      chol_n5,
      chol_n6,
      chol_n7,
      chol_n8,
      chol_n9,
      chol_n10,
      chol_n11,
    ],
    color: "#2A6C8F",
  },

  // Oficinas provisionales Chevrolet Tegucigalpa
  {
    id: "21",
    title: "Oficinas provisionales Chevrolet Tegucigalpa",
    category: "Proyectos Corporativos",
    location: "Tegucigalpa, Honduras",
    year: "2026",
    area: "350 m²",
    duration: "",
    status: "Completado",
    client: "Chevrolet Honduras",
    shortDescription:
      "Transformación de las instalaciones AUTOPITS en una moderna sede Chevrolet: fachadas de vidrio, pisos epóxicos y ambientes renovados.",
    fullDescription:
      "En este proyecto transformamos las antiguas instalaciones de AUTOPITS dentro de Grupo Q- Tegucigalpa, en una moderna y funcional sede de Chevrolet. La intervención incluyó la demolición y desmantelamiento de áreas existentes, renovación de fachadas de vidrio, pintura de cielo falso, paredes y pisos epóxicos, reparación de cubiertas, instalación de cielos falsos, movimiento mediante grúa de Tótem metálico, reutilización de piezas de ACM de antiguas instalaciones, etc. Obteniendo como resultado ambientes modernos y acordes a las necesidades del cliente.",
    highlights: [
      "Demolición y renovación integral de instalaciones",
      "Fachadas de vidrio y pisos epóxicos",
      "Movimiento de Tótem metálico con grúa",
      "Reutilización de piezas de ACM",
    ],
    coverImage: chev_cover,
    images: [
      chev1,
      chev2,
      chev3,
      chev4,
      chev5,
      chev6,
      chev7,
      chev8,
      chev9,
      chev10,
      chev11,
      chev12,
    ],
    color: "#064903",
  },

  // Oficinas provisionales Chevrolet SPS
  {
    id: "22",
    title: "Oficinas provisionales Chevrolet SPS",
    category: "Proyectos Corporativos",
    location: "San Pedro Sula, Honduras",
    year: "2026",
    area: "700 m²",
    duration: "",
    status: "En Proceso",
    client: "Chevrolet Honduras",
    shortDescription:
      "Adecuación de espacio existente en moderna sede provisional Chevrolet: fachada geométrica en ACM, showroom y oficinas comerciales.",
    fullDescription:
      "Proyecto de remodelación y adecuación integral de instalaciones provisionales para nuestro cliente, este proyecto está orientado a generar un cambio de imagen tanto en la fachada como en los espacios interiores, con especial énfasis en el área de oficinas. La intervención contempla la transformación y reorganización de los espacios existentes para adaptarlos a las necesidades operativas y funcionales del cliente, mediante una adecuada distribución de áreas, modulación de espacios y optimización de las superficies disponibles. El proyecto busca aprovechar al máximo las condiciones actuales de las instalaciones, incorporando una imagen renovada, funcional y coherente con las necesidades del usuario, logrando un equilibrio entre estética, funcionalidad y aprovechamiento eficiente del espacio.",
    highlights: [
      "Fachada geométrica en paneles ACM",
      "Showroom y área comercial renovados",
      "Cielos falsos y pisos de alto brillo",
      "Ventanería y fachada de vidrio",
    ],
    coverImage: chevsps_cover,
    images: [
      chevsps1,
      chevsps2,
      chevsps3,
      chevsps4,
      chevsps5,
    ],
    color: "#064903",
  },

  //COMPLEJO DE BODEGAS SERVELEC
  {
    id: "3",
    title: "COMPLEJO DE BODEGAS SERVELEC",
    category: "Edificaciones",
    location: "Tegucigalpa, Honduras",
    year: "2025",
    area: "3,000 m²",
    duration: "",
    status: "Completado",
    client: "Servelec",
    shortDescription:
      "Complejo de bodegas moderno que maximiza espacio y eficiencia para el crecimiento empresarial.",
    fullDescription:
      "Este proyecto de complejo de bodegas representa una apuesta sólida por  el crecimiento empresarial, integrando tres bodegas con un diseño moderno e inteligente que maximiza cada espacio disponible. La propuesta combina dos niveles subterráneos de estacionamientos y oficinas correspondientemente,  estratégicamente planificados para almacenamiento y operación, con una amplias areas para uso diverso de bodegas a nivel de calle de más de 500 m² que facilita el acceso directo y la logística diaria. Cada elemento ha sido concebido para brindar orden, versatilidad y alto rendimiento, dando como resultado un complejo que no solo responde a las exigencias actuales del mercado, sino que también proyecta innovación, solidez y una visión clara de desarrollo a largo plazo.",
    highlights: [
      "Logística eficiente y alto rendimiento",
      "Diseño moderno y optimización del espacio",
      "Bodegas amplias con acceso directo",
      "Niveles subterráneos funcionales",
    ],
    coverImage: img3_servelec,
    images: [
      img2_servelec,
      img1_servelec,
      img3_servelec,
      img7_servelec,
      img4_servelec,
      img5_servelec,
      img6_servelec,
    ],
    color: "#5C6D3A",
  },

  //Cancha
  {
    id: "4",
    title: "CANCHA MULTIDEPORTIVA",
    category: "Infraestructura Civil",
    location: "El Paraiso, Honduras",
    year: "2025",
    area: "435 m²",
    duration: " ",
    status: "Completado",
    client: "Alcaldia Texiguat",
    shortDescription:
      "Espacio comunitario, combinando deporte, cultura y convivencia con diseño funcional y de calidad.",
    fullDescription:
      "Este proyecto es la  representación de un espacio que va más allá de lo deportivo: es un punto de encuentro para toda la comunidad. Donde la tarea de nuestra empresa era  diseñar y construir un espacio donde toda la comunidad se pudiera ver beneficiada e incluida, este espacio no solamente es una cancha donde los niños, jóvenes y adultos realizan deporte, sino que también es un espacio cultural del municipio el cual convergen reuniones religiosas, ferias patronales, celebraciones, eventos, desfiles, etc. De tal forma se construyó un área llamativa y vibrante, cuidadosamente cuidando su diseño y su funcionalidad y sobre todo la calidad",
    highlights: [
      "Espacio deportivo y comunitario",
      "Punto de encuentro inclusivo",
      "Uso cultural y social diverso",
      "Diseño funcional y de calidad",
    ],
    coverImage: img1_cancha,
    images: [
      img1_cancha,
      img2_cancha,
      img3_cancha,
      img4_cancha,
      img5_cancha,
      img6_cancha,
      img7_cancha,
    ],
    color: "#8F2A2A",
  },

  // Diseño de Viviendas
  {
    id: "11",
    title: "Diseño de Viviendas",
    category: "Diseño e Ingeniería",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Diseño arquitectónico de viviendas modernas que combinan estética contemporánea, funcionalidad y confort.",
    fullDescription:
      "Nuestro servicio de diseño de viviendas combina arquitectura contemporánea con soluciones funcionales adaptadas a cada cliente. Desarrollamos proyectos residenciales que integran espacios amplios, iluminación natural, acabados de calidad y una estética moderna que refleja la personalidad y el estilo de vida de cada familia. Desde la concepción del diseño hasta los planos constructivos, acompañamos al cliente en cada etapa para garantizar que el resultado final supere sus expectativas.",
    highlights: [
      "Diseño arquitectónico personalizado",
      "Integración de espacios y luz natural",
      "Acabados modernos de alta calidad",
      "Acompañamiento en todo el proceso",
    ],
    hideTechSheet: true,
    coverImage: dise3_viv,
    images: [dise3_viv, dise_w1, dise_w3, dise_w2, dise_w4, dise2_viv, dise1_viv],
    color: "#0B6B3A",
  },

  // Puente Peatonal
  {
    id: "5",
    title: "Construcción de puente peatonal sobre río Grande",
    category: "Infraestructura Civil",
    location: "Nueva Armenia, Honduras",
    year: "2025",
    area: "110 ml",
    duration: "6 meses",
    status: "Completado",
    client: "Alcaldía Municipal de Nueva Armenia",
    shortDescription:
      "Conecta comunidades con seguridad y eficiencia, aportando movilidad, confianza y desarrollo.",
    fullDescription:
      "Este proyecto de construcción de puente peatonal es una conexión directa entre comunidades, seguridad y progreso comunitario, Desde su concepción, se ha trabajado con una visión clara de funcionalidad y diseño, creando una estructura que no solo facilita el tránsito seguro de peatones, sino que también aporta orden y modernidad al entorno. Cada etapa constructiva refleja compromiso, precisión y calidad, integrando soluciones resistentes y duraderas que responden a las necesidades reales de la zona. El resultado es un puente que inspira confianza, mejora la movilidad y se convierte en un símbolo de desarrollo y bienestar para todos los que lo utilizan.",
    highlights: [
      "Conexión segura entre comunidades",
      "Diseño funcional y moderno",
      "Estructura resistente y duradera",
      "Mejora de movilidad comunitaria",
    ],
    coverImage: img6_puente,
    images: [
      img1_puente,
      img2_puente,
      img3_puente,
      img4_puente,
      img5_puente,
      img6_puente,
      img7_puente,
    ],
    color: "#4A2A8F",
  },

  // Huellas
  {
    id: "7",
    title: "Huellas vehiculares de concreto hidráulico",
    category: "Infraestructura Civil",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Construcción de huellas de concreto que conectan comunidades rurales con accesos seguros y duraderos.",
    fullDescription:
      "Este proyecto de construcción de huellas de concreto representa una solución vial adaptada al terreno montañoso de Honduras, brindando acceso seguro y permanente a comunidades rurales. Las huellas fueron diseñadas con un acabado estriado antideslizante, garantizando tracción en pendientes y condiciones climáticas adversas. Cada tramo fue ejecutado con precisión constructiva, integrando obras de drenaje para proteger la infraestructura a largo plazo. El resultado es una vía funcional, resistente y de bajo mantenimiento que transforma la movilidad de las familias beneficiadas.",
    highlights: [
      "Acabado antideslizante en pendientes",
      "Integración de obras de drenaje",
      "Acceso permanente a comunidades rurales",
      "Alta durabilidad y bajo mantenimiento",
    ],
    hideTechSheet: true,
    coverImage: img22_huellas,
    images: [
      img22_huellas,
      img12_huellas,
      img6_huellas,
      img14_huellas,
      img10_huellas,
      img19_huellas,
      img18_huellas,
      img15_huellas,
      img9_huellas,
      img11_huellas,
      img16_huellas,
      img3_huellas,
      img1_huellas,
    ],
    color: "#3F4447",
  },

  // Adoquinado
  {
    id: "8",
    title: "Adoquinado",
    category: "Infraestructura Civil",
    location: "Honduras",
    year: "2025",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Construcción de calles adoquinadas que transforman la imagen y movilidad de comunidades rurales.",
    fullDescription:
      "Este proyecto de adoquinado transformó calles de tierra en vías pavimentadas, ordenadas y duraderas para comunidades rurales de Honduras. Se colocaron adoquines de concreto de alta resistencia con un patrón uniforme. Los trabajos incluyeron preparación de la base, colocación manual de adoquines con precisión artesanal, y sellado final. El resultado son calles que mejoran la imagen urbana, facilitan el tránsito vehicular y peatonal, y resisten las condiciones climáticas de la zona.",
    highlights: [
      "Adoquines de concreto de alta resistencia",
      "Colocación manual con precisión artesanal",
      "Preparación y compactación de base",
      "Mejora de imagen y movilidad comunitaria",
    ],
    hideTechSheet: true,
    coverImage: img12_adoq,
    images: [
      img12_adoq,
      img11_adoq,
      img7_adoq,
      img8_adoq,
      img6_adoq,
      img1_adoq,
      img4_adoq,
      img3_adoq,
      img5_adoq,
    ],
    color: "#3F4447",
  },

  // Pavimento de Concreto Hidráulico
  {
    id: "9",
    title: "Pavimento de Concreto Hidráulico",
    category: "Infraestructura Civil",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Pavimentación de calles con concreto hidráulico de alta resistencia, brindando vías seguras y duraderas a la comunidad.",
    fullDescription:
      "Este proyecto de pavimentación con concreto hidráulico transformó las calles de Nueva Armenia, Francisco Morazán, dotando a la comunidad de vías seguras, resistentes y de larga vida útil. La ejecución incluyó la preparación de la base, fundición de losas de concreto de alta resistencia y acabado con bordillos pintados, logrando calles funcionales que mejoran la movilidad y la calidad de vida de los residentes. Cada tramo fue ejecutado con rigor técnico para garantizar un pavimento uniforme, libre de fisuras y capaz de soportar el tráfico vehicular diario.",
    highlights: [
      "Losas de concreto de alta resistencia",
      "Bordillos y señalización incluidos",
      "Mejora de movilidad comunitaria",
      "Acabado uniforme y duradero",
    ],
    hideTechSheet: true,
    coverImage: pav_w7,
    images: [
      pav_w7,
      pav_w3,
      pav_w4,
      pav_w6,
      pav_w1,
      pav_w8,
      pav_w5,
      pav_w2,
      img13_pav,
      img7_pav,
      img12_pav,
    ],
    color: "#3F4447",
  },

  // Mantenimiento de carreteras
  {
    id: "10",
    title: "Mantenimiento de Carreteras",
    category: "Infraestructura Civil",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Trabajos de mantenimiento vial con maquinaria pesada para rehabilitar y mejorar carreteras de acceso comunitario.",
    fullDescription:
      "Este proyecto de mantenimiento de carreteras abarcó labores de nivelación, conformación y compactación de vías de acceso utilizando maquinaria pesada especializada — motoniveladoras, retroexcavadoras y compactadoras. Los trabajos incluyeron limpieza de derrumbes, reconformación de la capa de rodadura y apertura de cunetas para garantizar el drenaje adecuado. El resultado son vías transitables, seguras y en mejores condiciones para las comunidades que dependen de estas rutas en su día a día.",
    highlights: [
      "Nivelación y compactación con maquinaria pesada",
      "Limpieza de derrumbes y despejes",
      "Reconformación de capa de rodadura",
      "Apertura y mantenimiento de cunetas",
    ],
    hideTechSheet: true,
    coverImage: img1_mant,
    images: [
      img1_mant,
      img2_mant,
      img6_mant,
      img7_mant,
      img5_mant,
      img4_mant,
      img8_mant,
      img9_mant,
      img3_mant,
      img11_mant,
      img12_mant,
    ],
    color: "#3F4447",
  },

  // COMERCIO TATUMBLA
  {
    id: "6",
    title: "Remodelación plaza del comercio",
    category: "Remodelaciones y Adecuaciones",
    location: "Tatumbla, Honduras",
    year: "2025",
    area: "235 m²",
    duration: "1.5 meses",
    status: "Completado",
    client: "Alcaldía Municipal de Tatumbla",
    shortDescription:
      "Renovando la plaza comercial, mejorando su funcionalidad, imagen y dinamismo.",
    fullDescription:
      "Este proyecto de remodelación de la plaza de comercio en Tatumbla, Francisco Morazán, representa una revitalización integral de un espacio clave para la comunidad, transformándolo en un entorno más ordenado, atractivo y funcional. La intervención se enfoca en mejorar la imagen urbana mediante una propuesta arquitectónica limpia y contemporánea, que combina durabilidad y estética para dignificar el comercio local. Cada elemento ha sido pensado para optimizar la circulación, brindar comodidad tanto a comerciantes como a visitantes y fortalecer la identidad del lugar como punto de encuentro. El resultado es un espacio renovado que transmite dinamismo, organización y progreso, impulsando la actividad comercial y aportando valor al entorno urbano.",
    highlights: [
      "Revitalización de espacio comercial",
      "Diseño urbano moderno y funcional",
      "Mejora en circulación y comodidad",
      "Impulso al comercio local",
    ],
    coverImage:
      img3_Plaza,
    images: [
      img1_Plaza,
      img2_Plaza,
      img3_Plaza,
      img4_Plaza,
      img5_Plaza,
      img6_Plaza
    ],
    color: "#2A8F5C",
  },
  // Diseño de Sistemas de Agua Potable
  {
    id: "14",
    title: "Diseño de Sistemas de Agua Potable",
    category: "Diseño e Ingeniería",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Diseño y supervisión de sistemas de captación y distribución de agua potable para comunidades rurales.",
    fullDescription:
      "Este proyecto abarca el diseño integral de un sistema de agua potable para comunidades rurales, desde la identificación de fuentes hídricas naturales hasta la planificación de la red de distribución. El equipo técnico realizó levantamientos topográficos, estudios de caudal en ríos y quebradas, diseño de obras de captación y tanques de almacenamiento, y trazado de tuberías. El resultado es un sistema sostenible que garantiza acceso permanente a agua limpia, mejorando la calidad de vida y la salud de las familias beneficiadas.",
    highlights: [
      "Estudio de fuentes hídricas naturales",
      "Levantamiento topográfico de campo",
      "Diseño de captación y red de distribución",
      "Sistema sostenible para comunidades rurales",
    ],
    hideTechSheet: true,
    coverImage: agua3,
    images: [agua3, agua2, agua4, agua1, agua7, agua8, agua6, agua9, agua5],
    color: "#2A6C8F",
  },

  // Construcciones Escolares
  {
    id: "13",
    title: "Construcciones Escolares",
    category: "Edificaciones",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Construcción de aulas y servicios sanitarios escolares que brindan espacios dignos y funcionales para la educación.",
    fullDescription:
      "Este proyecto de construcción escolar refleja el compromiso de Consuprog con el desarrollo comunitario y la educación. Ejecutamos desde la cimentación hasta el acabado final, incluyendo aulas con grandes ventanales para iluminación natural, servicios sanitarios con azulejos y estructura metálica, y acabados en colores vivos que crean un ambiente acogedor para los estudiantes. Cada etapa fue desarrollada con rigor técnico y sensibilidad social, garantizando instalaciones duraderas que sirven a las comunidades por muchos años.",
    highlights: [
      "Aulas con iluminación natural optimizada",
      "Servicios sanitarios con acabados completos",
      "Estructura durable para uso intensivo",
      "Impacto social en comunidades educativas",
    ],
    hideTechSheet: true,
    coverImage: esc5,
    images: [esc5, esc6, esc7, esc4, esc1, esc2, esc3],
    color: "#1F8A4C",
  },

  // Construcción de Piscinas
  {
    id: "12",
    title: "Construcción de Piscinas",
    category: "Remodelaciones y Adecuaciones",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Construcción de piscinas residenciales con acabados en travertino, cascada decorativa y sistema de iluminación nocturna.",
    fullDescription:
      "Este proyecto de construcción de piscina residencial combina funcionalidad y estética para crear un espacio de descanso y recreación de alto nivel. La piscina cuenta con revestimiento en mosaico azul, deck perimetral en travertino, cascada decorativa en pared de piedra natural, pasamanos en acero inoxidable e iluminación arquitectónica nocturna que transforma el espacio al caer la noche. Cada detalle fue ejecutado con precisión para garantizar durabilidad, seguridad y una imagen impecable que complementa la vivienda.",
    highlights: [
      "Revestimiento en mosaico y travertino",
      "Cascada decorativa en piedra natural",
      "Iluminación arquitectónica nocturna",
      "Acero inoxidable y acabados premium",
    ],
    hideTechSheet: true,
    coverImage: pisc1,
    images: [pisc1, pisc_w2, pisc_w3, pisc_w4, pisc3, pisc2, pisc_w1, pisc_w5, pisc4],
    color: "#0B6B3A",
  },

  // Caja Puente Mayarán
  {
    id: "20",
    title: "Caja puente Mayarán",
    category: "Infraestructura Civil",
    location: "Mayarán, Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Construcción de caja puente de concreto reforzado sobre quebrada, con tablero vial, barandas metálicas y obras de encauzamiento.",
    fullDescription:
      "Este proyecto consistió en la construcción de una caja puente de concreto reforzado para cruce vehicular sobre quebrada en la comunidad de Mayarán. Los trabajos abarcaron excavación y preparación del cauce con maquinaria, construcción de muros de cajón en concreto armado con formaleta de madera, armado e instalación de malla de acero para el tablero vial, colado de losa de concreto y acabado superficial. La obra se ejecutó en condiciones de flujo activo de agua, lo que requirió control hidráulico durante el proceso. El resultado es una estructura sólida y duradera que garantiza la conectividad vial de la comunidad durante la época lluviosa.",
    highlights: [
      "Construcción de cajón en concreto armado",
      "Armado de malla de acero para tablero vial",
      "Colado de losa bajo condiciones de flujo activo",
      "Barandas metálicas y acabado vial completo",
    ],
    coverImage: may_w3,
    images: [may_w3, may_w4, may_w10, may_w9, may_w7, may_w6, may_w5, may_w8, may_w2, may_w1],
    color: "#3F4447",
  },

  // Estadio Municipal Soledad
  {
    id: "19",
    title: "Supervisión proyecto estadio municipal de Soledad el Paraíso",
    category: "Supervisión de Obra",
    location: "Soledad, El Paraíso, Honduras",
    year: "2023",
    area: "3,500 m²",
    duration: "",
    status: "Completado",
    client: "Alcaldía Municipal de Soledad",
    shortDescription:
      "Supervisión técnica de la construcción del estadio municipal de Soledad con cancha de pasto sintético y graderío techado.",
    fullDescription:
      "Este proyecto de supervisión técnica abarcó la construcción del estadio municipal de Soledad, El Paraíso, una obra de alto impacto deportivo y social para el municipio. La supervisión garantizó el cumplimiento de especificaciones en la instalación de pasto sintético de alta calidad, la construcción del graderío techado con estructura metálica, el cerramiento perimetral y las obras de terracería para la preparación de la plataforma deportiva. El estadio, integrado al paisaje montañoso del municipio, brinda a la comunidad un espacio deportivo de primer nivel que promueve el deporte y la sana convivencia.",
    highlights: [
      "Supervisión de instalación de pasto sintético",
      "Control de calidad en estructura de graderío techado",
      "Coordinación con Alcaldía Municipal de Soledad",
      "Infraestructura deportiva de impacto comunitario",
    ],
    coverImage: est_w2,
    images: [est_w2, est_w3, est_w7, est_w9, est_w5, est_w6, est_w1, est_w8, est_w4],
    color: "#0B6B3A",
  },

  // Obras de Terracería
  {
    id: "18",
    title: "Obras de Terracería",
    category: "Remodelaciones y Adecuaciones",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Trabajos de terracería con maquinaria pesada para preparación de terrenos, excavación, relleno y movimiento de materiales.",
    fullDescription:
      "Nuestros proyectos de terracería abarcan todas las etapas de preparación de suelo para construcción: excavación con retroexcavadora, relleno y compactación, limpieza y nivelación de lotes, así como carga y acarreo de material con camiones volquete. Contamos con flota propia de maquinaria pesada — retroexcavadoras John Deere, cargadores Hyundai y camiones volquete — lo que nos permite ejecutar proyectos urbanos y rurales con eficiencia y precisión. Cada trabajo se desarrolla respetando los parámetros técnicos del proyecto para garantizar una plataforma adecuada para las etapas constructivas posteriores.",
    highlights: [
      "Excavación y preparación de plataformas",
      "Carga y acarreo de material con volquetes",
      "Flota propia de maquinaria pesada",
      "Proyectos urbanos y en ladera",
    ],
    hideTechSheet: true,
    coverImage: terr_w3,
    images: [terr_w3, terr_w7, terr_w5, terr_w6, terr_w8, terr_w1, terr_w4, terr_w9, terr_w10, terr_w2],
    color: "#2A6C8F",
  },

  // Remodelación de Viviendas
  {
    id: "17",
    title: "Remodelación de viviendas",
    category: "Remodelaciones y Adecuaciones",
    location: "Honduras",
    year: "",
    area: "",
    duration: "",
    status: "Completado",
    client: "",
    shortDescription:
      "Remodelación integral de viviendas que transforman áreas habitacionales en espacios funcionales.",
    fullDescription:
      "Este proyecto de remodelación residencial abarca intervenciones integrales en viviendas, transformando espacios existentes en entornos modernos y funcionales. Los trabajos incluyen construcción de terrazas con cubierta metálica, deck de madera tratada e iluminación ambiental, instalación de estructura de madera y ventanería para espacios interiores, excavación y cimentación para ampliaciones, y renovación de fachadas y espacios exteriores. Cada proyecto se adapta a las necesidades del cliente, combinando materiales de calidad, buenas prácticas constructivas y un diseño que mejora la calidad de vida.",
    highlights: [
      "Construcción de terrazas y cubiertas",
      "Deck de madera tratada con iluminación ambiental",
      "Ampliaciones con cimentación y estructura nueva",
      "Renovación de fachadas y espacios exteriores",
    ],
    hideTechSheet: true,
    coverImage: remod_w1,
    images: [remod_w1, remod_w6, remod_w5, remod_w2, remod_w3, remod_w4],
    color: "#2A6C8F",
  },

  // Plaza Municipal Soledad
  {
    id: "16",
    title: "Supervisión Plaza Municipal Soledad",
    category: "Supervisión de Obra",
    location: "Soledad, El Paraíso, Honduras",
    year: "2024",
    area: "450 m²",
    duration: "",
    status: "Completado",
    client: "Alcaldía Municipal de Soledad",
    shortDescription:
      "Supervisión técnica de la construcción de la plaza municipal de Soledad, garantizando calidad en adoquinado, áreas verdes y espacios comunitarios.",
    fullDescription:
      "Este proyecto de supervisión técnica abarcó la construcción y remodelación de la plaza municipal de Soledad, El Paraíso. El trabajo de supervisión garantizó el cumplimiento de especificaciones técnicas en el adoquinado decorativo con patrones geométricos multicolor, la instalación de mobiliario urbano, áreas verdes, iluminación y elementos de identidad local. La plaza se convirtió en el punto de encuentro del municipio, integrando la Alcaldía Municipal, la iglesia colonial y espacios de convivencia en un entorno ordenado y funcional que dignifica a la comunidad.",
    highlights: [
      "Supervisión de adoquinado decorativo multicolor",
      "Control de calidad en mobiliario urbano",
      "Coordinación con Alcaldía Municipal",
      "Espacio comunitario renovado e integrado",
    ],
    coverImage: sol1,
    images: [sol1, sol2, sol3, sol4, sol5],
    color: "#0B6B3A",
  },
];

export const getCategoryColor = (category) => {
  const colors = {
    "Supervisión de Obra":          "#0B6B3A",
    "Infraestructura Civil":        "#3F4447",
    "Edificaciones":                "#1F8A4C",
    "Proyectos Corporativos":       "#064903",
    "Remodelaciones y Adecuaciones":"#2A6C8F",
    "Diseño e Ingeniería":          "#7A8288",
  };
  return colors[category] || "#3F4447";
};

export const getProjectById = (id) =>
  projectsData.find((p) => p.id === id) || null;
